import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PermissionServices } from '@/services/apis';

const initialState = {
  permissions: [],
  permissionsCreatedInSetup: [],
  permissionsCreatedInSetupCount: 0,
  loading: true,
  error: false,
  errorMessage: '',
  totalRecords: 0
};

export const fetchAllPermissions = createAsyncThunk(
  'permission/fetchAllPermissions',
  async ({ domainName, page, rowsPerPage, searchPermissionTerm, roleId, appName, appType, orgName }: any) => {
    const response = await PermissionServices.fetchPermissions({
      domainName,
      pageNumber: page,
      pageSize: rowsPerPage,
      organizationName: orgName,
      applicationType: appType,
      permissionName: searchPermissionTerm,
      roleId: roleId || ''
    });
    return response;
  }
);

export const fetchNewCreatedPermissions = createAsyncThunk(
  'permission/fetchNewCreatedPermissions',
  async ({ domainName, page, rowsPerPage, searchPermissionTerm, roleId, appName, appType, orgName }: any) => {
    const response = await PermissionServices.fetchPermissions({
      domainName,
      pageNumber: page,
      pageSize: rowsPerPage,
      organizationName: orgName,
      applicationType: appType,
      applicationName: appName,
      permissionName: searchPermissionTerm
    });
    return response;
  }
);

export const createNewPermission = createAsyncThunk('permission/createNewPermission', async (permissionData: any) => {
  const data = await PermissionServices.createPermission(permissionData);
  return data;
});

export const updatePermission = createAsyncThunk('permission/updatePermission', async (permissionData: any) => {
  const { permId, ...finalData } = permissionData;
  const data = await PermissionServices.updatePermission(finalData, permId);
  return data;
});

export const deletePermission = createAsyncThunk('permission/deletePermission', async (permission: any) => {
  const data = await PermissionServices.deletePermission(permission);
  return data;
});

export const deleteBulkPermission = createAsyncThunk('permission/deleteBulkPermission', async (permissions: any) => {
  const data = await PermissionServices.deleteBulkPermission(permissions);
  return data;
});

export const downloadPermission = createAsyncThunk('permission/downloadPermission', async () => {
  const response = await PermissionServices.downloadPermission();
  return response;
});
export const downloadCsv = createAsyncThunk('permission/downloadCsv', async () => {
  const response = await PermissionServices.downloadCsv();
  return response;
});

export const uploadPermissions = createAsyncThunk(
  'group/uploadPermissions',
  async ({ dom_name,org_name, data, created_by, modified_by, status,app_name,app_type,perm_type,role_type  }: any) => {
    const response = await PermissionServices.uploadCsv({ dom_name,org_name,app_name,app_type, perm_type, role_type , data, created_by, modified_by, status });
    return response;
  }
);
export const PermissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllPermissions.pending, (state) => {});
    builder.addCase(fetchAllPermissions.fulfilled, (state, { payload }) => {
      return { ...state, permissions: payload?.result?.permission, totalRecords: payload?.totalRecords, loading: false };
    });
    builder.addCase(fetchAllPermissions.rejected, (state) => {
      return { ...state, permissions: [], totalRecords: 0, loading: false };
    });
    builder.addCase(fetchNewCreatedPermissions.pending, (state) => {});
    builder.addCase(fetchNewCreatedPermissions.fulfilled, (state, { payload }) => {
      return {
        ...state,
        permissionsCreatedInSetup: payload?.result?.permission,
        permissionsCreatedInSetupCount: payload?.totalRecords,
        loading: false
      };
    });
    builder.addCase(fetchNewCreatedPermissions.rejected, (state) => {
      return { ...state, permissionsCreatedInSetup: [], permissionsCreatedInSetupCount: 0, loading: false };
    });
  }
});

export const permissionSelector = (state: any) => state.domain;

export default PermissionSlice.reducer;
